import React from "react"

export class Footer extends React.Component {

    render() {

        const {lang} = this.props
        const l = lang.lang

        return (
            <>
                <footer id={'footer'} className="footer border border-1 shadow-top">
                    <div className={'d-flex flex-nowrap justify-content-center'}>
                        <p className={'m-0 p-0'}>{`© 2023 "us-link.cloud" ${lang.footer.rights}`}&nbsp;</p>
                        <a href={`/${l}/policy`}>{`${lang.footer.policy}`}</a>
                    </div>
                </footer>
            </>
        )
    }
}